<template>
  <div class="password">
    <div class="password-container">
      <img src="../../assets/image/login/bg-left.png" class="bg-left" />
      <img src="../../assets/image/login/bg-right.png" class="bg-right" />
      <div class="password-box">
        <div class="password-title">{{ passwordTit }}</div>

        <div class="password-main">
          <div class="password-step" v-if="step != 3">
            <div
              class="step-item"
              :class="{ 'step-active': step == 1 || step == 2 || step == 4 }"
            >
              <img
                src="../../assets/image/login/step1-active.png"
                class="step1-img"
                v-if="step == 1 || step == 4 || step == 2"
              />
              <img
                src="../../assets/image/login/step1.png"
                class="step1-img"
                v-else
              />
              <div>验证手机号</div>
            </div>
            <div class="step-line"></div>
            <div class="step-item" :class="{ 'step-active': step == 2 }">
              <img
                src="../../assets/image/login/step2.png"
                class="step2-img"
                v-if="step == 1 || step == 4"
              />
              <img
                src="../../assets/image/login/step2-active.png"
                class="step2-img"
                v-else
              />
              <div>设置新密码</div>
            </div>
            <div class="step-line"></div>
            <div class="step-item">
              <img src="../../assets/image/login/step3.png" class="step3-img" />
              <div>密码修改成功</div>
            </div>
          </div>
          <div class="password-form" v-show="step == 1">
            <el-form :model="verifyForm" :rules="verifyRules" ref="verifyForm">
              <el-form-item prop="phoneNumber">
                <el-input
                  v-model="verifyForm.phoneNumber"
                  @input="getUserNameOrEmailAddress"
                  maxlength="11"
                  placeholder="请输入手机号"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-input v-model="verifyForm.code" placeholder="请输入验证码">
                  <el-button
                    type="text"
                    slot="suffix"
                    :disabled="isCodedisabled"
                    class="message-code"
                    :class="isCodedisabled ? 'is-disabled' : 'is-normal'"
                    @click="readyLog"
                    >{{ codeBtn }}</el-button
                  >
                </el-input>
              </el-form-item>
            </el-form>
            <el-button type="primary" class="next-btn" @click="continueStep"
              >下一步</el-button
            >
            <div class="password-tip">
              <span>手机号已不再使用？</span>
              <span class="tip-color">请联系人工客服</span>
            </div>
          </div>
          <div class="password-form" v-show="step == 2">
            <el-form
              :model="passwordForm"
              :rules="passwordRules"
              ref="passwordForms"
            >
              <el-form-item prop="password">
                <el-input
                  type="password"
                  v-model="passwordForm.password"
                  :placeholder="passwordTips"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item prop="confirmPassword">
                <el-input
                  type="password"
                  v-model="passwordForm.confirmPassword"
                  placeholder="请再次输入新密码"
                  clearable
                ></el-input>
              </el-form-item>
            </el-form>
            <el-button
              type="primary"
              class="next-btn"
              @click="resetPassword"
              :loading="isLoading"
              >重置密码</el-button
            >
          </div>

          <div class="psaaword-success" v-if="step == 3">
            <img
              src="../../assets/image/login/success.png"
              class="success-img"
            />
            <div class="success-text">密码修改成功，后续可通过新密码登录！</div>
            <el-button type="primary" class="success-btn" @click="goLogin"
              >立即登录</el-button
            >
          </div>

          <div class="password-form" v-show="step == 4">
            <el-form
              :model="passwordForm"
              :rules="passwordRules"
              ref="passwordForm"
            >
              <el-form-item prop="tenantIds">
                <div class="tips">
                  检测到该手机号下有多个关联账号，请选择账号（可多选）
                </div>
                <el-select
                  v-model="tenantIds"
                  multiple
                  collapse-tags
                  placeholder="请选择账号"
                >
                  <el-option
                    v-for="item in tenants"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-button
              type="primary"
              class="next-btn tenant-btn"
              @click="selectTenant"
              >确认</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="选择租户"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-select
        v-model="tenantIds"
        multiple
        collapse-tags
        placeholder="请选择租户"
      >
        <el-option
          v-for="item in tenants"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <div class="btn">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="selectTenant">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { validatePhone, isvalidUsername } from "@/utils/validate";
import { forgotPass } from "@/http/api/employe";
import { verifyCode } from "@/http/api/utility";
import { getTenantsLogin } from "@/http/api/account";
import { getPublicIdentitySettings } from "@/http/api/system";
export default {
  data() {
    const validatephoneNumber = (rule, value, callback) => {
      if (!isvalidUsername(value)) {
        callback(new Error("请输入手机号"));
      } else {
        if (!validatePhone(value)) {
          callback(new Error("手机号输入不正确"));
        } else {
          callback();
        }
      }
    };
    const validatePassword = (rule, value, callback) => {
      let len = this.passwordOptions.length;
      if (!value) {
        callback(new Error(`密码不能为空`));
      } else if (value.length < len) {
        callback(new Error(`密码最少${len}位数`));
      } else if (
        this.passwordOptions.requireLowercase &&
        !/[a-z]/.test(value)
      ) {
        callback(new Error(`密码应包含小写字母`));
      } else if (
        this.passwordOptions.requireUppercase &&
        !/[A-Z]/.test(value)
      ) {
        callback(new Error(`密码应包含大写字母`));
      } else if (this.passwordOptions.requireDigit && !/[0-9]/.test(value)) {
        callback(new Error(`密码应包含数字`));
      } else if (
        this.passwordOptions.requireNonAlphanumeric &&
        !/[^a-zA-Z0-9]/.test(value)
      ) {
        callback(new Error(`密码应包含非字母数字`));
      } else {
        callback();
      }
    };
    const validateConfirmPassword = (rule, value, callback) => {
      if (value.length == 0) {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.passwordForm.password) {
        callback(new Error("两次密码不一致"));
      } else {
        callback();
      }
    };
    return {
      passwordTit: "找回密码",
      step: 1,
      isCodedisabled: true,
      isLoading: false,
      tenants: [],
      tenantIds: [],
      dialogVisible: false,
      time: 120,
      passwordTips: "请输入新密码",
      passwordOptions: {
        length: "",
        requireLowercase: "",
        requireUppercase: "",
        requireDigit: "",
        user: "",
        requireNonAlphanumeric: "",
      },
      verifyForm: {
        phoneNumber: "",
        code: "",
      },
      passwordForm: {
        password: "",
        confirmPassword: "",
      },
      verifyRules: {
        phoneNumber: [
          { required: true, trigger: "blur", validator: validatephoneNumber },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      passwordRules: {
        password: [
          { required: true, trigger: "blur", validator: validatePassword },
        ],
        confirmPassword: [
          {
            required: true,
            trigger: "blur",
            validator: validateConfirmPassword,
          },
        ],
      },
      codeBtn: "发送验证码",
    };
  },
  mounted() {
    this.$refs.verifyForm.resetFields();
    this.$refs.passwordForm.resetFields();
    //console.log(this.$route, "redirect");
    this.getPublicIdentitySettings();
  },
  watch: {
    $route: {
      handler: function (route) {
        //console.log("路径", route);
        // if (route.query.redirect != "/login/forgetPassword") {
        //   this.$emit("switch-status");
        // }
      },
      immediate: true,
    },
  },
  methods: {
    // 获取密码配置
    getPublicIdentitySettings() {
      getPublicIdentitySettings().then((res) => {
        res.result.map((el) => {
          if (el.name == "Rocket.Identity.Password.RequiredLength") {
            this.passwordOptions.length = el.value;
          } else if (el.name == "Rocket.Identity.Password.RequireLowercase") {
            this.passwordOptions.requireLowercase = el.value;
          } else if (el.name == "Rocket.Identity.Password.RequireUppercase") {
            this.passwordOptions.requireUppercase = el.value;
          } else if (el.name == "Rocket.Identity.Password.RequireDigit") {
            this.passwordOptions.requireDigit = el.value;
          } else if (el.name == "Rocket.Identity.Password.User") {
            this.passwordOptions.user = el.value;
          } else if (
            el.name == "Rocket.Identity.Password.RequireNonAlphanumeric"
          ) {
            this.passwordOptions.requireNonAlphanumeric = el.value;
          }
        });
        this.passwordTips = `包含${
          this.passwordOptions.requireLowercase ? "小写字母" : ""
        }${this.passwordOptions.requireUppercase ? " 大写字母" : ""}${
          this.passwordOptions.requireDigit ? " 数字" : ""
        }${
          this.passwordOptions.requireNonAlphanumeric ? " 非字母数字" : ""
        }，最少${this.passwordOptions.length}位`;
        console.log(this.passwordTips,"passwordTips");
      });
    },
    getUserNameOrEmailAddress() {
      if (/^1[34578]\d{9}$/.test(this.verifyForm.phoneNumber)) {
        this.isCodedisabled = false;
      } else {
        this.isCodedisabled = true;
      }
    },
    //选择租户
    selectTenant() {
      this.step = 2;
    },
    handleClose() {},
    handleSelectionChange() {},
    cancelEnroll() {},
    readyLog() {
      let query = {
        userNameOrEmailAddress: this.verifyForm.phoneNumber,
      };
      getTenantsLogin(query).then((res) => {
        //console.log(res.result, "获取的数据");
        this.tenants = res.result;
        if (res.result.length == 0) {
          this.$message({
            message: "该手机号暂未注册",
            showClose: true,
          });
        } else if (res.result.length == 1) {
          this.tenantIds = [this.tenants[0].id];
          this.sendCode();
        } else {
          this.sendCode();
        }
      });
    },
    sendCode() {
      this.isCodedisabled = true;
      this.$store
        .dispatch("GetCode", this.verifyForm.phoneNumber)
        .then((res) => {
          //console.log(res);
          this.time = 120;
          this.timer();
        })
        .catch((err) => {
          //console.log(err);
        });
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        this.codeBtn = this.time + "s后重新获取";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.codeBtn = "发送验证码";
        if (/^1[34578]\d{9}$/.test(this.verifyForm.phoneNumber)) {
          this.isCodedisabled = false;
        } else {
          this.isCodedisabled = true;
        }
      }
    },
    // 下一步
    continueStep() {
      this.$refs.verifyForm.validate((valid) => {
        if (valid) {
          verifyCode(this.verifyForm.phoneNumber, this.verifyForm.code)
            .then((res) => {
              //console.log(res, "获取的验证码验证数据");
              if (this.tenants.length > 1) {
                this.step = 4;
              } else {
                this.step = 2;
              }
            })
            .catch((err) => {
              this.$message({
                message: err.msg,
                type: "error",
                showClose: true,
              });
            });
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 重置密码
    resetPassword() {
      this.$refs.passwordForms.validate((valid) => {
        if (valid) {
          this.isLoading = true;
          let params = {
            phoneNumberOrEmailAddress: this.verifyForm.phoneNumber,
            code: this.verifyForm.code,
            password: this.passwordForm.password,
            confirmPassword: this.passwordForm.confirmPassword,
            tenantIds: this.tenantIds,
          };
          forgotPass(params)
            .then((res) => {
              //console.log(res);
              this.step = 3;
              this.passwordTit = "密码修改成功";
              this.isLoading = false;
            })
            .catch((err) => {
              this.$message({
                message: err.message,
                type: "error",
                showClose: true,
              });
              this.isLoading = false;
            });
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    goLogin() {
      this.$router.go(0);
    },
  },
};
</script>

<style lang='scss' scoped>
.password {
  text-align: center;
  width: 100%;
  height: 100vh;
  background-color: #f0f0f5;
  .password-top {
    display: flex;
    align-items: center;

    width: 100%;
    height: 60px;
    background: #212b4b;

    img {
      margin-left: 40px;
      width: 158px;
      height: 32px;
    }
  }

  .password-container {
    position: relative;
    padding: 40px 212px 0;
    box-sizing: border-box;
    width: 100%;
    height: calc(100vh - 130px);
    background-color: #f0f0f5;

    .bg-left {
      position: absolute;
      left: 0;
      top: 87px;

      width: 338px;
      height: 348px;
    }

    .bg-right {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);

      width: 330px;
      height: 346px;
    }

    .password-box {
      position: relative;
      width: 100%;
      height: 100%;
      min-height: 520px;
      background: #fff;
      box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.3);
      z-index: 9;

      .password-title {
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid #e5e5ea;
        height: 18.4%;
        font-size: 32px;
        font-weight: 400;
        color: #000;
      }

      .password-main {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        height: 81.6%;
        min-height: 480px;
        .password-step {
          display: flex;
          margin: 40px 0 70px;

          .step-item {
            font-size: 17px;
            font-weight: 400;
            color: #999;
          }

          img {
            height: 16px;
            margin-bottom: 10px;
          }

          .step1-img {
            width: 8px;
          }

          .step2-img {
            width: 12px;
          }

          .step3-img {
            width: 11px;
          }

          .step-line {
            margin: 0 -20px;
            position: relative;
            top: 7px;

            width: 199px;
            height: 1px;
            background: #cacaca;
          }

          .step-active {
            color: $--color-primary;

            & + .step-line {
              background: $--color-primary;
            }
          }
        }

        .password-form {
          .tips {
            margin-bottom: 10px;
            margin-left: -40px;
            font-size: 14px;
            color: #999;
          }
          .el-form-item {
            margin-bottom: 25px;

            .el-input {
              ::v-deep input {
                height: 100%;
              }
            }
            ::v-deep .el-select {
              width: 100%;
              height: 40px;
              .el-input {
                height: 100%;
                input {
                  height: 100%;
                }
              }
            }
            ::v-deep .el-input__suffix-inner {
              display: inline-block;
              height: 100%;
              .message-code {
                position: relative;
                right: 20px;

                height: 100%;
                font-size: 14px;

                &:focus,
                &:hover {
                  background-color: transparent;
                  border-color: transparent;
                }
              }

              .is-disabled {
                color: #e0e0e0;
              }

              .is-normal {
                color: $--color-primary;
              }
            }
          }

          .next-btn {
            width: 100%;
            height: 40px;
            background-color: $--color-primary;
            border-color: $--color-primary;
          }
          .tenant-btn {
            margin-top: 65px;
          }

          .password-tip {
            margin-top: 18px;
            color: #666;
            .tip-color {
              color: $--color-primary;
            }
          }
        }

        @media (max-width: 1919px) {
          .password-form {
            width: 400px;

            .el-form-item {
              height: 40px;

              .el-input {
                height: 40px;
              }

              ::v-deep .el-form-item__error {
                top: 95%;
              }
            }

            .next-btn {
              height: 40px;

              ::v-deep span {
                font-size: 14px;
              }
            }
          }
        }

        @media (min-width: 1920px) {
          .password-form {
            width: 450px;

            .el-form-item {
              height: 50px;

              .el-input {
                height: 50px;
              }

              ::v-deep .el-input__inner {
                &::placeholder {
                  font-size: 14px;
                }
              }

              ::v-deep .el-form-item__error {
                top: 100%;
              }
            }

            .next-btn {
              height: 50px;

              ::v-deep span {
                font-size: 18px;
              }
            }
          }
        }

        .psaaword-success {
          position: absolute;
          top: 40%;
          left: 50%;
          transform: translate(-50%, -50%);

          .success-img {
            width: 88px;
            height: 88px;
          }

          .success-text {
            font-size: 20px;
            font-weight: 400;
            color: #474747;
          }

          .success-btn {
            width: 151px;
            height: 50px;
            background: $--color-primary;
          }

          @media (max-width: 1919px) {
            .success-btn {
              height: 40px;

              ::v-deep span {
                font-size: 14px;
              }
            }

            .success-text {
              margin: 30px 0 40px;
            }
          }

          @media (min-width: 1920px) {
            .success-btn {
              height: 50px;

              ::v-deep span {
                font-size: 18px;
              }
            }

            .success-text {
              margin: 40px 0 50px;
            }
          }
        }
      }
    }
  }
  .el-dialog {
    .el-select {
      width: 80%;
      margin-bottom: 20px;
    }
    .btn {
      // text-align: left;
    }
  }
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  color: #006eff !important;
}
</style>